export default __webpack_public_path__ + "static/media/back_button.5bb71445.svg";